<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        Production Status Historical Records
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>
<hr class="my-0">

<mat-dialog-content #pageContainer style="padding: 5px;">

    <div class="text-center text-3xl py-6">
        <b>{{ wellDetails.stringShortName }}</b>
    </div>

    <table class="table table-zebra text-center table-border-bottom">
        <thead class="header">
            <tr class="text-center tableHeader-bg-color">
                <td> Field </td>
                <td> Platform </td>
                <td> String Indicator </td>
                <td> Production Status </td>
                <td> Updated By </td>
                <td> Updated Date </td>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="(wellHistoricalRecords$ | async) as wellHistoricalRecords ; else noData">
                <ng-container *ngIf="wellHistoricalRecords.data.length > 0 ; else noData">
                    <tr *ngFor="let wellHistoricalRecord of wellHistoricalRecords.data;  let j = index">
                        <td>{{ wellHistoricalRecord.fieldLongName }}</td>
                        <td>{{ wellHistoricalRecord.platformLongName }}</td>
                        <td>{{ wellHistoricalRecord.stringIndicatorShortName }}</td>
                        <td>{{ wellHistoricalRecord.prodStatus }}</td>
                        <td>{{ wellHistoricalRecord.lastUpdatedBy }}</td>
                        <td>{{ handleFormatDate(wellHistoricalRecord.lastUpdatedDate,false) }}</td>
                    </tr>
                </ng-container>
            </ng-container>
        </tbody>

        <ng-template #noData>
            <tr>
                <td style="background-color: #f5f5f5;" colspan="10">No data available</td>
            </tr>
        </ng-template>
    </table>
</mat-dialog-content>


<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>